import { UseFormReturn } from 'react-hook-form';

import { FormField, FormItem, FormMessage } from '@@/ui/primitives';
import { Field } from '../../../../schemas/entity';
import { CreateItemPayload } from '../../../../schemas/item';
import { NumberInput } from '../../../shared/field-inputs';

interface NumberFieldRendererProps {
  fieldKey: string;
  field: Field;
  form: UseFormReturn<CreateItemPayload['attributes']>;
  label: string;
  disabled?: boolean;
}

export function NumberFieldRenderer({ fieldKey, field, form, label, disabled = false }: NumberFieldRendererProps) {
  const definition = field.definition;

  if (definition.type !== 'number') {
    return null;
  }

  return (
    <FormField
      control={form.control}
      name={fieldKey}
      render={({ field: formField }) => (
        <FormItem>
          <NumberInput
            value={formField.value}
            onChange={formField.onChange}
            label={label}
            placeholder={`Enter ${fieldKey}...`}
            min={definition.minimum}
            max={definition.maximum}
            disabled={disabled}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
